import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import ui from './uiReducer';
import user from './userReducer';
import monitors from './monitorsReducer';
import jobs from './jobsReducer';
import eCommerce from './eCommerceReducer';
import site from './siteReducer';
import notifications from './notificationsReducer';
import integrations from './integrationsReducer';
import users from './usersReducer';
import statusPage from './statusPageReducer';

const appReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    ui,
    user,
    monitors,
    jobs,
    eCommerce,
    site,
    notifications,
    integrations,
    users,
    statusPage,
  });

const rootReducer = (history) => (state, action) => {
  // When logout action is dispatched, reset all reducers to their initial state
  if (action.type === 'LOGOUT') {
    // The router state should be preserved to avoid navigation issues
    const { router } = state;
    state = { router };
  }

  return appReducer(history)(state, action);
};

export default rootReducer;
